import * as Actions from '../actions/auth.actions';
import * as Constants from '../actions/auth.constants';
import { AuthState } from '../types/auth-state';

const defaultState: Partial<AuthState> = {};

export function reducer(state: Partial<AuthState> = defaultState, action: Actions.All)
  : Partial<AuthState> {

  switch (action.type) {
    case Constants.LOGIN:
      const { email } = action as Actions.LoginAction;
      return { ...state, login_loading: true, message: undefined, email };
    case Constants.LOGIN_SUCCESS: {
      const { token, uid, sysadmin, newUser } = action as Actions.LoginSuccessAction;
      return { ...state, login_loading: false, token, uid, sysadmin, message: undefined, newUser };
    }
    case Constants.LOGIN_FAILED:
      const { message } = action as Actions.LoginFailedAction;
      return { ...state, login_loading: false, message };
    case Constants.TOKEN_REFRESH: {
      const { token } = action as Actions.TokenRefreshAction;
      return { ...state, token };
    }
    case Constants.INVALIDATE_SESSION:
      return { ...defaultState };
    case Constants.USER_CHANGED_PASSWORD:
      return { ...state, newUser: false };
    default:
      return state;
  }
}